import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

interface ICircleCustom {
    size: number
}

export const CircleCustom = styled(Box)<ICircleCustom>`
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    background-color: var(--chakra-colors-lime-300);
    color: var(--chakra-colors-primary-500);

    width: ${props => `${props.size}px`};
    height: ${props => `${props.size}px`};
`
